"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HelpText = exports.HelpList = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _coreListGroup = _interopRequireDefault(require("@vfuk/core-list-group"));
var _coreListItem = _interopRequireDefault(require("@vfuk/core-list-item"));
var _coreInteraction = require("@vfuk/core-interaction");
var _coreMixins = require("@vfuk/core-mixins");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}

/* eslint-disable max-len */
var HelpList = (0, _styledComponents["default"])(_coreListGroup["default"]).withConfig({
  displayName: "HelpTextstyle__HelpList",
  componentId: "sc-11w81gr-0"
})(function () {
  return (0, _styledComponents.css)(["", ";"], (0, _coreMixins.spacing)('margin-top', 2));
});
exports.HelpList = HelpList;
var HelpText = (0, _styledComponents["default"])(_coreListItem["default"]).withConfig({
  displayName: "HelpTextstyle__HelpText",
  componentId: "sc-11w81gr-1"
})(function (props) {
  return (0, _styledComponents.css)(["", ";color:", ";", " ", "{color:", ";border-bottom:", " ", " ", ";display:inline-block;width:auto;}"], _coreMixins.typography.paragraph(1, false), props.theme.formFields.color, props.state === 'disabled' && (0, _styledComponents.css)(["color:", ";"], props.theme.formFields.state.disabled.color), _coreInteraction.InteractionStyles.Interaction, props.theme.formLabels.color, props.theme.formFields.border.width, props.theme.formFields.border.style, props.theme.formFields.border.color);
});
exports.HelpText = HelpText;